import list from '../data/list';

export default {
    data() {
        return {
            data: {},
            list,
            center: { lng: 0, lat: 0 }, //经纬度
            zoom: 12 //地图展示级别
        }
    },

    created() {
        this.getInfo();
    },

    methods: {

        handler({ BMap, map }) {
            let _this = this;
            let myGeo = new BMap.Geocoder();
            myGeo.getPoint(_this.data.address,(point) => {
                console.log(point)
                this.center = point
            })
        },

        getClickInfo(e) {
            console.log(e.point.lng);
            console.log(e.point.lat);
            this.center.lng = e.point.lng;
            this.center.lat = e.point.lat;
        },

        getInfo() {
            this.$post('api.php/Index/aboutUs').then(res => {
                if(res.status == 1) {
                    this.data = res.data || {};
                }
            })
        }
    }
}
